/**
 * cart-recommendations.js
 * Sahara 3.0.0 (Dawn-based cart drawer)
 *
 * Add-to-cart uses the same Sections API flow as cart.js / cart-drawer.js:
 * POST cart/add.js with sections ? cart-drawer.renderContents()
 */

(function () {
  'use strict';

  function getDrawerSections() {
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
      return cartDrawer.getSectionsToRender().map((s) => s.section);
    }
    return ['cart-counter', 'cart-drawer'];
  }

  async function addToCartAndRenderDrawer(variantId) {
    const cartDrawer = document.querySelector('cart-drawer');
    const sections = getDrawerSections();

    const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify({
        id: Number(variantId),
        quantity: 1,
        sections: sections.join(','),
        sections_url: window.location.pathname,
      }),
    });

    const responseJson = await response.json();

    if (responseJson.status) {
      throw new Error(
        responseJson.description || responseJson.message || 'Cart add failed'
      );
    }

    if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
      cartDrawer.renderContents(responseJson, true);
    }

    if (typeof updateFreeShipping === 'function') {
      updateFreeShipping();
    }

    return responseJson;
  }

  class CartRecommendations extends HTMLElement {
    connectedCallback() {
      this._fetchRecommendations();
    }

    _fetchRecommendations() {
      const url = this.dataset.url;
      if (!url) return;

      fetch(url)
        .then((r) => r.text())
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const wrapper = doc.querySelector('[data-recommendations]');
          if (!wrapper) return;
          if (!wrapper.querySelectorAll('.swiper-slide').length) return;

          const local = this.querySelector('[data-recommendations]');
          if (local) local.innerHTML = wrapper.innerHTML;

          this.classList.remove('hidden');
          this._initSwiper();
          this._bindAddToCart();
        })
        .catch((e) => console.warn('[CartRec] fetch error:', e));
    }

    _initSwiper() {
      if (typeof Swiper === 'undefined') {
        setTimeout(() => this._initSwiper(), 200);
        return;
      }

      const swiperEl = this.querySelector('.swiper');
      if (!swiperEl) return;

      if (this._swiper) {
        this._swiper.destroy(true, true);
        this._swiper = null;
      }

      const elCurrent = this.querySelector('.cart-recommendations__counter-current');
      const elTotal = this.querySelector('.cart-recommendations__counter-total');
      const btnPrev = this.querySelector('.cart-recommendations__nav-prev');
      const btnNext = this.querySelector('.cart-recommendations__nav-next');

      this._swiper = new Swiper(swiperEl, {
        slidesPerView: 1,
        spaceBetween: 10,
        loop: true,
        autoplay: {
          delay: 3500,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        },
        on: {
          init(sw) {
            const real = sw.slides.filter(
              (s) => !s.classList.contains('swiper-slide-duplicate')
            ).length;
            if (elTotal) elTotal.textContent = real;
            if (elCurrent) elCurrent.textContent = 1;
          },
          realIndexChange(sw) {
            if (elCurrent) elCurrent.textContent = sw.realIndex + 1;
          },
        },
      });

      if (btnPrev) btnPrev.addEventListener('click', () => this._swiper?.slidePrev());
      if (btnNext) btnNext.addEventListener('click', () => this._swiper?.slideNext());
    }

    _bindAddToCart() {
      this.querySelectorAll('.cart-recommendations__add-btn:not([disabled])').forEach(
        (btn) => {
          const clone = btn.cloneNode(true);
          btn.replaceWith(clone);
          clone.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            this._addToCart(clone);
          });
        }
      );
    }

    async _addToCart(btn) {
      const variantId = btn.dataset.variantId;
      if (!variantId) return;

      const originalText = btn.textContent.trim();
      btn.disabled = true;
      btn.classList.add('cart-recommendations__add-btn--loading');
      btn.textContent = '.';

      try {
        await addToCartAndRenderDrawer(variantId);
      } catch (err) {
        console.warn('[CartRec] add-to-cart error:', err);
        if (btn.isConnected) {
          btn.textContent = originalText;
          btn.disabled = false;
          btn.classList.remove('cart-recommendations__add-btn--loading');
        }
      }
    }
  }

  if (!customElements.get('cart-recommendations')) {
    customElements.define('cart-recommendations', CartRecommendations);
  }
})();